import React from 'react'
import { useNotify } from '@globaleris/ui.library'
import { useSelector } from 'react-redux'
import { RootStoreModel, clearErrors } from '../../../redux'

export const Notifier: React.FC = () => {
  const { error } = useNotify()
  const errorMessage = useSelector(
    (state: RootStoreModel) => state.notifications && state.notifications.error
  )
  if (errorMessage !== '') {
    errorMessage && error(errorMessage)
    clearErrors()
  }
  return <></>
}
